/**
 * @desc 根据系统单号列表获取订单包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.listPackageBySoOrderNos.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/systemOrderPackage/listPackageBySoOrderNos`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
